import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useForm } from "react-hook-form";
import { IClientCompanyDropdown } from "../../models/IDropdown";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Toolbar } from "primereact/toolbar";

interface IForm {
  open: boolean;
  singleData: any;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IMassMailForm {
  name: string;
  email: string;
  vendor_Company: IClientCompanyDropdown | null;
}

export const Form = ({
  open,
  singleData,
  hideDialog,
  toast,
  reload,
  setReload,
}: IForm) => {
  const [file, setFile] = useState<File | null>(null);
  const [saveDis, setSaveDis] = useState(false);
  const [errorEmails, setErrorEmails] = useState<any[]>([]);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [clientCompanies, setClientCompanies] = useState<
    Array<IClientCompanyDropdown>
  >([]);
  const [uploadingAgain, setUploadingAgain] = useState(false);
  const [alreadyUploaded, setAlreadyUploaded] = useState(false);
  const isEdit = !!singleData?.id;

  const { control, handleSubmit, reset, setValue } = useForm<IMassMailForm>({
    defaultValues: {
      name: "",
      email: "",
      vendor_Company: null,
    },
  });

  const loadClientCompanies = async (filter: string | null) => {
    const response = await Fetch(
      "MassMail/vendor_companies",
      "GET",
      null,
      `filter=${filter}`,
      null,
    );
    if (response) {
      const data: Array<IClientCompanyDropdown> = await response.json();
      setClientCompanies(data);
    }
  };

  const completeMethod = (event: { query: string }) => {
    loadClientCompanies(event.query);
  };

  useEffect(() => {
    loadClientCompanies(null);
    if (open && singleData.vendor_Company_ID) {
      loadClientCompanies(singleData.vendor_Company_Name);
      reset({
        name: singleData.name ?? "",
        email: singleData.email ?? "",
        vendor_Company: {
          vendor_Company_ID: singleData.vendor_Company_ID,
          vendor_Company_Name: singleData.vendor_Company_Name,
          website_URL: "",
        },
      });
    } else if (singleData && singleData.id) {
      reset({
        name: singleData.name ?? "",
        email: singleData.email ?? "",
        vendor_Company: singleData.vendor_Company ?? null,
      });
      setFile(null);
    } else {
      reset({
        name: "",
        email: "",
        vendor_Company: null,
      });
      setFile(null);
    }
  }, [open, reset]);

  // useEffect(() => {
  //   if (singleData && singleData.id) {
  //     reset({
  //       name: singleData.name ?? "",
  //       email: singleData.email ?? "",
  //       vendor_Company: singleData.vendor_Company ?? null,
  //     });
  //     setFile(null);
  //   } else {
  //     reset({
  //       name: "",
  //       email: "",
  //       vendor_Company: null,
  //     });
  //     setFile(null);
  //   }
  // }, [singleData, reset]);

  const handleDownload = () => {
    if (!errorEmails.length) return;

    const headers = ["Type", "Name", "Email"];

    const rows = errorEmails.map((row) => [
      row.type || "",
      row.name || "",
      row.email || "",
    ]);

    let csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Invalid_Emails.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const rightToolbar = () => {
    return (
      <div className="flex gap-2">
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={handleDownload}
        />
      </div>
    );
  };

  const onCellEditComplete = (e: any) => {
    const { rowIndex, newValue, field, originalEvent } = e;

    setErrorEmails((prev) => {
      const updated = [...prev];

      if (field === "name") {
        if (!newValue || !newValue.trim()) {
          originalEvent.preventDefault();
          return prev;
        }
      }

      // if (field === "email") {
      //   if (!isValidEmail(newValue)) {
      //     originalEvent.preventDefault();
      //     return prev;
      //   }
      // }
      if (field === "email") {
        if (!newValue || !newValue.trim()) {
          originalEvent.preventDefault();
          return prev;
        }
      }

      updated[rowIndex] = {
        ...updated[rowIndex],
        [field]: newValue,
      };

      return updated;
    });
  };

  const cellEditor = (options: ColumnEditorOptions) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (options.editorCallback) {
        options.editorCallback(e.target.value);
      }
    };

    return (
      <input
        style={{
          width: "100%",
          margin: 0,
          padding: "3px 5px",
          border: "2px solid green",
          cursor: "pointer",
        }}
        value={options.value || ""}
        type="text"
        onChange={(e) => handleChange(e)}
      />
    );
  };

  const onSubmit = async (data: IMassMailForm) => {
    setSaveDis(true);

    try {
      let response: Response | any = null;

      if (!isEdit) {
        if (!file) {
          toast.current.show({
            severity: "warn",
            detail: "Please upload Excel file",
            life: 3000,
          });
          setSaveDis(false);
          return;
        }

        const formData = new FormData();
        formData.append("excelFile", file);

        response = await fetch(`${baseUrl}MassMail/uploadExcel`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || "{}")?.token
              }`,
          },
          body: formData,
        });

        if (!response.ok) {
          const result = await response.json();
          toast.current.show({
            severity: "error",
            detail: result.message || "Upload failed",
            life: 3000,
          });
          setSaveDis(false);
          return;
        } else {
          const result: any = await response.json();

          const invalidEmails = [
            ...(result.emailValidate?.emails || []).map(
              (el: { name: string; email: string }) => ({
                name: el.name,
                email: el.email,
                type: "Invalid Email",
              }),
            ),

            ...(result.emailVendorValidate?.emails || []).map(
              (el: { name: string; email: string }) => ({
                name: el.name,
                email: el.email,
                type: "Vendor Not Found",
              }),
            ),

            ...(result.emailDuplicate?.emails || []).map(
              (el: { name: string; email: string }) => ({
                name: el.name,
                email: el.email,
                type: "Duplicate Email",
              }),
            ),

            ...(result.nameValidate?.emails || []).map(
              (el: { name: string; email: string }) => ({
                name: el.name,
                email: el.email,
                type: "Invalid Name",
              }),
            ),
          ];

          if (invalidEmails.length > 0) {
            setErrorEmails(invalidEmails);
            setShowErrorDialog(true);
          } else {
            toast.current.show({
              severity: "success",
              detail: "Excel uploaded successfully",
              life: 3000,
            });
            setReload((prev) => !prev);
            hideDialog();
          }
        }

        setReload((prev) => !prev);
      } else {
        const body = {
          id: singleData.id,
          name: data.name,
          email: data.email,
          vendor_Company_ID: data.vendor_Company?.vendor_Company_ID,
        };

        response = await Fetch("MassMail", "PUT", body, null, toast);

        if (response && response.ok) {
          setReload((prev) => !prev);
          toast.current.show({
            severity: "success",
            detail: "Updated Successfully",
            life: 3000,
          });
        } else {
          // const result = await response.json();
          // toast.current.show({
          //   severity: "error",
          //   detail: result.message || "Update failed",
          //   life: 3000,
          // });
          setSaveDis(false);
          return;
        }
      }

      hideDialog();
    } catch (err: any) {
      toast.current.show({
        severity: "error",
        detail: err.message || "Something went wrong",
        life: 3000,
      });
    } finally {
      setSaveDis(false);
    }

    setReload(!reload);
  };

  const fileUploadRef = useRef<FileUpload>(null);
  const handleClear = () => {
    reset();
    setFile(null);
    fileUploadRef.current?.clear();
    // hideDialog();
  };

  const handleErrorClear = () => {
    setErrorEmails(errorEmails.map((e) => ({ ...e, email: "", name: "" })));
  };
  return (
    <>
      <Dialog
        visible={open}
        onHide={hideDialog}
        header={isEdit ? "Edit Email Entry" : "Upload Mass Mail"}
        modal
        style={{ width: "40vw" }}
        className="p-fluid"
      >
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          {!isEdit && (
            <div className="col-12">
              <label>Upload Excel File *</label>
              <FileUpload
                ref={fileUploadRef}
                mode="basic"
                accept=".xls,.xlsx,.csv"
                chooseLabel="Choose Excel"
                customUpload
                auto={false}
                onSelect={(e) => {
                  setFile(e.files?.[0] || null);
                  setAlreadyUploaded(false);
                  setUploadingAgain(false);
                  setErrorEmails([]);
                }}
              />
            </div>
          )}

          {isEdit && (
            <>
              <div className="col-12 ml-3">
                <label>Name</label>
                <input
                  className="p-inputtext w-full"
                  {...control.register("name")}
                />
              </div>

              <div className="col-12 ml-3 mt-3">
                <label>Email</label>
                <input
                  className="p-inputtext w-full"
                  {...control.register("email")}
                />
              </div>

              <div className="col-12 d-flex justify-content-start mt-3">
                <JVDropdownInput
                  required
                  completeMethod={completeMethod}
                  column={1}
                  label="Client Company Name"
                  control={control}
                  name="vendor_Company"
                  options={clientCompanies}
                  optionLabel="vendor_Company_Name"
                  placeholder="Search Client Company"
                />
              </div>
            </>
          )}

          <div className="col-12 flex justify-content-end gap-2 mt-5">
            <Button label="SAVE" type="submit" disabled={saveDis} />
            <Button
              label="CLEAR"
              type="button"
              onClick={handleClear}
              className="p-button-outlined"
            />
          </div>
        </form>
      </Dialog>

      <Dialog
        visible={showErrorDialog}
        header="Fix Email Errors"
        modal
        style={{ width: "50vw" }}
        onHide={() => setShowErrorDialog(false)}
      >
        <Toolbar className="mb-1 py-0" right={rightToolbar}></Toolbar>
        <DataTable
          value={errorEmails}
          editMode="cell"
          showGridlines
          stripedRows
          responsiveLayout="scroll"
        >
          <Column field="type" header="Error Type" />

          <Column
            field="name"
            header="Name"
            body={(rowData: any) => <p>{rowData.name}</p>}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />

          <Column
            field="email"
            header="Email"
            body={(rowData: any) => <p>{rowData.email}</p>}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
        </DataTable>

        <div className="flex justify-content-end mt-4 gap-2">
          <Button
            label={alreadyUploaded ? "Close" : "Upload Again"}
            disabled={!alreadyUploaded && uploadingAgain}
            onClick={async () => {
              if (alreadyUploaded) {
                setShowErrorDialog(false);
                setErrorEmails([]);
                setAlreadyUploaded(false);
                return;
              }

              try {
                setUploadingAgain(true);

                const response = await Fetch(
                  "MassMail/uploadExcelAgain",
                  "POST",
                  errorEmails,
                  null,
                  toast,
                );

                if (response && response.ok) {
                  const result = await response.json();

                  const stillInvalid = [
                    ...(result.emailValidate?.emails || []).map((el: any) => ({
                      name: el.name,
                      email: el.email,
                      type: "Invalid Email",
                    })),
                    ...(result.emailDuplicate?.emails || []).map((el: any) => ({
                      name: el.name,
                      email: el.email,
                      type: "Duplicate Email",
                    })),
                    ...(result.emailVendorValidate?.emails || []).map(
                      (el: any) => ({
                        name: el.name,
                        email: el.email,
                        type: "Vendor Not Found",
                      }),
                    ),
                    ...(result.nameValidate?.emails || []).map((el: any) => ({
                      name: el.name,
                      email: el.email,
                      type: "Invalid Name",
                    })),
                  ];

                  setAlreadyUploaded(true);

                  if (stillInvalid.length > 0) {
                    setErrorEmails(stillInvalid);
                  }

                  toast.current.show({
                    severity: "success",
                    detail: "Upload process completed",
                    life: 3000,
                  });
                }
              } finally {
                setUploadingAgain(false);
              }
            }}
          />

          {/* <Button
            label="CLEAR"
            type="button"
            onClick={handleErrorClear}
            className="p-button-outlined"
          /> */}
        </div>
      </Dialog>
    </>
  );
};
